import { FC, useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import FooterText from "../../components/footerText";
import AuthSubHeader from "src/components/authSubHeader";

import { ToastContext } from "src/context/toastContext";
import useFetch from "src/hooks/useFetch";

import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";
import { LoaderContext } from "src/context/loaderContext";
import { UploadEOBsResponse } from "./types";


const UploadEOBs: FC = (): JSX.Element => {


  const [uploadFile, changeUploadFile] = useState<FileList | null>(null);
  const navigate = useNavigate();
  const ref = useRef<HTMLInputElement>(null);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);




  const { loading: isFileUploading, error: uploadEOBsError, data: uploadEOBsData, mutate: uploadEOBsSubmit } =
    useFetch<UploadEOBsResponse>(APIEndpoints.EOBs_Upload);

  useEffect(() => {
    if (uploadEOBsData || uploadEOBsError) {
      hideLoader()
      if (uploadEOBsData) {
        showToast([`EOB uploaded successfully.`], ToastTypes.SUCCESS);
        clearDataAndForm()
        navigate('/explanationOfBenefit');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadEOBsData, uploadEOBsError]);

  const uploadFileData = () => {
    if (uploadFile) {
      const formData = new FormData();
      formData.append("eob_document", uploadFile[0]);
      formData.append("active", "false");
      setLoader();
      uploadEOBsSubmit(formData);
    }
  };





  const reset = () => {
    if (ref && ref.current) {
      ref.current.value = ""
    }
  };

  const clearDataAndForm = () => {
    changeUploadFile(null);
    reset();
  };





  return (
    <div className="container-fluid overflow-auto d-flex flex-fill">
      <div className="container container-short d-flex flex-column flex-fill">
        <AuthSubHeader />
        <div className="flex-fill">
          <div className="card mt-4">
            <div className="card-header bg-success-subtle">
              <h4 className="mb-0 text-black">
                Upload EOB
              </h4>
            </div>
            <div className="card-body">
              <form>
                <p>
                  Please select and upload an Explanation of Benefits to have our team de-identify it and add it to the library of EOBs in our EOB Warehouse. Note that it will not appear in the searchable list until the de-identification process has been completed.
                </p>
                <div className="input-group mb-2">
                  <input
                      type="file" className="form-control" id="fileUpload"
                      onChange={(e) => changeUploadFile(e.target.files)} ref={ref}
                  />
                  {uploadFile ? (
                      <>
                        <button
                            className="btn btn-outline-secondary me-2" onClick={clearDataAndForm} type="button"
                            id="fileUpload" disabled={isFileUploading}
                        >
                          Clear
                        </button>

                      </>
                  ) : null}
                    <button
                        className="btn btn-blue rounded-1" type="button" name="cancel"
                        onClick={() => uploadFileData()}
                        disabled={isFileUploading}
                    >
                        Upload
                    </button>
                </div>
                {/* <small className="d-block">
                  Click here to upload the patient's chart. Currently we accept .txt, .pdf, .tiff, .doc, .ccd, .cda,
                  .ccr, .ccda and image files.
                </small> */}
              </form>
            </div>
          </div>

          {/* <NewPrecertComp /> */}
        </div>
        <div className="mt-3"><FooterText/></div>
      </div>
    </div>
  );
};
export default UploadEOBs;
